import { render, staticRenderFns } from "./card-three.vue?vue&type=template&id=56672c11&scoped=true&"
import script from "./card-three.vue?vue&type=script&lang=js&"
export * from "./card-three.vue?vue&type=script&lang=js&"
import style0 from "./card-three.vue?vue&type=style&index=0&id=56672c11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56672c11",
  null
  
)

export default component.exports